import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table } from "antd";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { AI_PROCESSING_LOG_COLUMNS, AUDIT_LOG_COLUMNS } from "../constant/AppConstant";
import { useDeleteAuditLogMutation, useGetAllAuditLogsWithPaginationMutation, useSearchAuditLogsMutation } from "../../redux-toolkit/services/auditLogService";
import { getAuditLogData, getAuditLogDataBySearch, getAuditLogTotalRecords, setAuditLogs, setAuditLogsBySearch } from "../../redux-toolkit/slices/auditLogSlice";
import { useDeleteAIProcessingLogMutation, useGetAllAIProcessingLogsWithPaginationMutation, useSearchAIProcessingLogsMutation } from "../../redux-toolkit/services/aiProcessingLogService";
import { getAIProcessingLogData, getAIProcessingLogDataBySearch, getAIProcessingLogTotalRecords, setAIProcessingLogs, setAIProcessingLogsBySearch } from "../../redux-toolkit/slices/aiProcessingLogSlice";

type Props = {};
const AuditLoggingReports = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");


    // getMutations
    const [getAllAuditLogsWithPagination, getAllAuditLogsWithPaginationResponse] = useGetAllAuditLogsWithPaginationMutation();
    const [getAllAIProcessingLogsWithPagination, getAllAIProcessingLogsWithPaginationResponse] = useGetAllAIProcessingLogsWithPaginationMutation();

    // get by search
    const [searchAuditLogs, searchAuditLogsResponse] = useSearchAuditLogsMutation();
    const [searchAIProcessingLogs, searchAIProcessingLogsResponse] = useSearchAIProcessingLogsMutation();

    // delete mutation
    const [deleteAuditLogs, deleteAuditLogsResponse] = useDeleteAuditLogMutation();
    const [deleteAIProcessingLogs, deleteAIProcessingLogsResponse] = useDeleteAIProcessingLogMutation();


    // totalRecords
    const totalAuditLogs: any = useAppSelector(getAuditLogTotalRecords);
    const totalAIProcessingLogs: any = useAppSelector(getAIProcessingLogTotalRecords);

    // selectors
    const auditLogsSearchData: any = useAppSelector(getAuditLogDataBySearch);
    const auditLogsData: any = useAppSelector(getAuditLogData);
    const aIProcessingLogsSearchData: any = useAppSelector(getAIProcessingLogDataBySearch);
    const aIProcessingLogsData: any = useAppSelector(getAIProcessingLogData);


    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.AUDIT_LOG:
                setReportName(REPORT_NAME.AUDIT_LOG)
                break;
            case REPORT_PATH.AI_PROCESSING_LOG:
                setReportName(REPORT_NAME.AI_PROCESSING_LOG)
                break;
            default:
        }
    }, [params.reportType]);



    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                       
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.AUDIT_LOG && AUDIT_LOG_COLUMNS) {
            AUDIT_LOG_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG && AI_PROCESSING_LOG_COLUMNS) {
            AI_PROCESSING_LOG_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.AUDIT_LOG) {
            getAllAuditLogsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            getAllAIProcessingLogsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
    }, [reportName]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.AUDIT_LOG) {
                getAllAuditLogsWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG) {
                getAllAIProcessingLogsWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            setCall("N");
        }
    }, [call]);


    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.AUDIT_LOG) {
            getAllAuditLogsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            getAllAIProcessingLogsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }

        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };


    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.AUDIT_LOG) {
            deleteAuditLogs({
                id: record.id,
                token: token
            })
        } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            deleteAIProcessingLogs({
                id: record.id,
                token: token
            })
        }

    };


    useEffect(() => {
        if (deleteAuditLogsResponse.isSuccess) {
            if (deleteAuditLogsResponse.data?.isActive) {
                alertMessage("Audit Log enabled successfully", "success");
            } else {
                alertMessage("Audit Log deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAuditLogsResponse.isError) {
            alertMessage("Error while deleting Audit Log", "error");
        }
    }, [
        deleteAuditLogsResponse.isSuccess,
        deleteAuditLogsResponse.isError,
    ]);

    useEffect(() => {
        if (deleteAIProcessingLogsResponse.isSuccess) {
            if (deleteAIProcessingLogsResponse.data?.isActive) {
                alertMessage("AI Processing Log enabled successfully", "success");
            } else {
                alertMessage("AI Processing Log deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAIProcessingLogsResponse.isError) {
            alertMessage("Error while deleting AI Processing Log", "error");
        }
    }, [
        deleteAIProcessingLogsResponse.isSuccess,
        deleteAIProcessingLogsResponse.isError,
    ]);



    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.AUDIT_LOG) {
            searchAuditLogs({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            searchAIProcessingLogs({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };


    useEffect(() => {
        if (searchAuditLogsResponse.isSuccess) {
            dispatch(setAuditLogsBySearch(searchAuditLogsResponse));
        } else if (searchAuditLogsResponse.isError) {
            let response: any = searchAuditLogsResponse.error;
            alertMessage(response, "error");
        }
    }, [searchAuditLogsResponse.isSuccess, searchAuditLogsResponse.isError]);

    useEffect(() => {
        if (searchAIProcessingLogsResponse.isSuccess) {
            dispatch(setAIProcessingLogsBySearch(searchAIProcessingLogsResponse));
        } else if (searchAIProcessingLogsResponse.isError) {
            let response: any = searchAIProcessingLogsResponse.error;
            alertMessage(response, "error");
        }
    }, [searchAIProcessingLogsResponse.isSuccess, searchAIProcessingLogsResponse.isError]);


    useEffect(() => {
        if (getAllAuditLogsWithPaginationResponse.isSuccess) {
            dispatch(setAuditLogs(getAllAuditLogsWithPaginationResponse));
        } else if (getAllAuditLogsWithPaginationResponse.isError) {
            let response: any = getAllAuditLogsWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAuditLogsWithPaginationResponse.isSuccess, getAllAuditLogsWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAllAIProcessingLogsWithPaginationResponse.isSuccess) {
            dispatch(setAIProcessingLogs(getAllAIProcessingLogsWithPaginationResponse));
        } else if (getAllAIProcessingLogsWithPaginationResponse.isError) {
            let response: any = getAllAIProcessingLogsWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAIProcessingLogsWithPaginationResponse.isSuccess, getAllAIProcessingLogsWithPaginationResponse.isError]);


    useEffect(() => {
        if (aIProcessingLogsSearchData && reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            setDatasource(aIProcessingLogsSearchData);
        }
    }, [aIProcessingLogsSearchData]);

    useEffect(() => {
        if (aIProcessingLogsData && reportName === REPORT_NAME.AI_PROCESSING_LOG) {
            setDatasource(aIProcessingLogsData);
        }
    }, [aIProcessingLogsData]);



    useEffect(() => {
        if (auditLogsSearchData && reportName === REPORT_NAME.AUDIT_LOG) {
            setDatasource(auditLogsSearchData);
        }
    }, [auditLogsSearchData]);



    useEffect(() => {
        if (auditLogsData && reportName === REPORT_NAME.AUDIT_LOG) {
            setDatasource(auditLogsData);
        }
    }, [auditLogsData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                          { reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>
                    {
                            getAllAuditLogsWithPaginationResponse.isLoading ||
                            getAllAIProcessingLogsWithPaginationResponse.isLoading ||
                            searchAuditLogsResponse.isLoading ||
                            searchAIProcessingLogsResponse.isLoading ||
                            deleteAuditLogsResponse.isLoading ||
                            deleteAIProcessingLogsResponse.isLoading ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    }

                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.AUDIT_LOG:
                                    return totalAuditLogs;
                                case REPORT_NAME.AI_PROCESSING_LOG:
                                    return totalAIProcessingLogs;
                                default:
                                    return [];
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default AuditLoggingReports;